import { Link, useNavigate } from 'react-router-dom';
import icon1 from "../../../adminassets/img/avatars/1.png";
import { toggleMode, selectMode } from '../../../service/slice/ThemeSlice';
import { userDetails, setUser } from '../../../service/slice/AuthSlice';
import { useDispatch, useSelector } from 'react-redux';
import { MdOutlineLightMode } from "react-icons/md";
import { MdOutlineDarkMode } from "react-icons/md";
import { useEffect, useState } from 'react';


export default function Navbar() {

    const theme = useSelector(selectMode);
    const details = useSelector((state) => state.userSlice?.value);
    const dispatch = useDispatch();

    const [admiDetails, setAdminDetails] = useState(details);

    const navigate = useNavigate();

    useEffect(() => {
        setAdminDetails(details);
    }, [details])

    function logout() {
        localStorage.removeItem('authAdminToken');
        dispatch(setUser({ userDetails: undefined }))
        // navigate('/adminSignin')
        window.location.href = "/adminSignin";
    }

    return (
        <>
            <nav className="layout-navbar container-xxl navbar-detached navbar navbar-expand-xl align-items-center bg-navbar-theme" id="layout-navbar">
                <div className="layout-menu-toggle navbar-nav align-items-xl-center me-4 me-xl-0 d-xl-none">
                    <Link className="nav-item nav-link px-0 me-xl-6" to="#">
                        <i className="icon-base ri ri-menu-line icon-22px"></i>
                    </Link>
                </div>

                <div className="navbar-nav-right d-flex align-items-center justify-content-end" id="navbar-collapse">
                    <div className="navbar-nav align-items-center">
                        <div className="nav-item navbar-search-wrapper mb-0">
                            <Link className="nav-item nav-link search-toggler px-0" to="#">
                                <span className="d-inline-block text-body-secondary fw-normal" id="autocomplete"></span>
                            </Link>
                        </div>
                    </div>

                    <ul className="navbar-nav flex-row align-items-center ms-md-auto">

                        <li className="nav-item dropdown me-sm-2 me-xl-0">
                            <button className="theme-toggle-btn" onClick={() => dispatch(toggleMode())} >
                                {theme === "light" ? <MdOutlineLightMode /> : <MdOutlineDarkMode />}
                            </button>
                        </li>


                        <li className="nav-item navbar-dropdown dropdown-user dropdown ms-2 p-2">
                            <Link className="nav-link dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                <div className="avatar avatar-online">
                                    <img src={icon1} alt="avatar" className="rounded-circle" />
                                </div>
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-end mt-3 py-2" >
                                <li>
                                    <Link className="dropdown-item" to="#">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0 me-2">
                                                <div className="avatar avatar-online">
                                                    <img src={icon1} alt="alt" className="w-px-40 h-auto rounded-circle" />
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h6 className="mb-0 small">{admiDetails?.first_name}</h6>
                                                <small className="text-body-secondary">{admiDetails?.email}</small>
                                            </div>
                                        </div>
                                    </Link>
                                </li>
                                <li>
                                    <div className="dropdown-divider"></div>
                                </li>

                                {/* <li>
                                    <Link className="dropdown-item" to="/admin/customerdetails" >
                                        <i className="icon-base ri ri-user-3-line icon-22px me-3"></i><span className="align-middle">My Profile</span>
                                    </Link>
                                </li> */}

                                {/* <li>
                                    <Link className="dropdown-item" to="#" >
                                        <i className="icon-base ri ri-settings-4-line icon-22px me-3"></i>
                                        <span className="align-middle">Settings</span>
                                    </Link>
                                </li> */}

                                <li>
                                    <div className="d-grid px-4 pt-2 pb-1">
                                        <Link className="btn btn-sm btn-danger d-flex justify-content-center align-items-center" onClick={() => { logout() }}>
                                            <small className="align-middle">Logout</small>
                                            <i className="icon-base ri ri-logout-box-r-line ms-2 icon-16px"></i>
                                        </Link>
                                    </div>
                                </li>

                            </ul>
                        </li>

                    </ul>
                </div>
            </nav>
        </>
    )
}
